const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';


export async function signupWithEmail(email: string, password: string, nickname: string, phone: string) {
    const res = await fetch(`${API_BASE_URL}/user/auth/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, nickname, phone_number : phone }),
    });

    if (res.status === 400) {
      const error = await res.text();
      alert(error);
      return
    }
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Signup failed');
    }
    return res.json();
  }
  
  export async function loginWithEmail(email: string, password: string) {
    const res = await fetch(`${API_BASE_URL}/user/auth/signin`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Login failed');
    }
  
    const data = await res.json();

    
    if (data.body && data.body.user_token) {
      localStorage.setItem('user_token', data.body.user_token);
      localStorage.setItem("refresh_token", data.body.user_refresh_token);
      localStorage.setItem("userId", data.body.user_id);
    } else {
      throw new Error('No token received');
    }
  
    return data;
  }
  
  export async function logout(token: string) {
    const res = await fetch('/user/auth/logout', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Logout failed');
    }
    return res.json();
  }

  export async function checkEmail(email: string) {
    const res = await fetch(`${API_BASE_URL}/user/auth/check-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Email check failed');
    }
  
    return res.json();
  }
  
  export async function sendVerificationCode(phone_number: string, country_id: number, sms_message: string) {
    const res = await fetch(`https://api.batonserver.com/user/generate/verification_number`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone_number, country_id, sms_message }),
    });
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Failed to send verification code');
    }
  
    return res.json();
  }
  
  export async function verifyCode(phone_number: string, random_number: string) {
    const res = await fetch(`https://api.batonserver.com/user/verify/verification_number`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone_number, random_number }),
    });
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Verification failed');
    }
  
    return res.json();
  }
  
  export async function checkNickname(nickname: string) {
    const res = await fetch(`${API_BASE_URL}/user/auth/check-nickname`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ nickname }),
    });
  
    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Nickname check failed');
    }
  
    return res.json();
  }


 export async function refreshToken() {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      throw new Error("No refresh token found");
    }

    const res = await fetch(`${API_BASE_URL}/user/auth/renew_session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });

    if (!res.ok) {
      const error = await res.text();
      throw new Error(error || 'Token refresh failed');
    }

    const data = await res.json();
    localStorage.setItem('user_token', data.body.user_token);
    return data;
 }
 
 async function apiRequest(input: RequestInfo, init?: RequestInit): Promise<Response> {
   const token = localStorage.getItem('user_token');
 
   const headers: Record<string, string> = {
     ...(init?.headers as Record<string, string>),
     'Authorization': token ? `Bearer ${token}` : '',
   };
 
   try {
     let res = await fetch(input, { ...init, headers });
 
     if (res.status === 401) {
       // 토큰 만료 가능성 -> refresh token으로 갱신
       try {
         const data = await refreshToken(); // 새 access token 발급
         localStorage.setItem('user_token', data.body.access_token);
 
         // 다시 원래 요청 재시도
         const retryHeaders = {
           ...(init?.headers as Record<string, string>),
           'Authorization': `Bearer ${data.body.access_token}`,
         };
         res = await fetch(input, { ...init, headers: retryHeaders });
       } catch (refreshErr) {
         // refresh token도 만료됨 -> 강제 로그아웃
         localStorage.removeItem('user_token');
         localStorage.removeItem('refresh_token');
         window.alert('세션이 만료되었습니다. 다시 로그인해주세요.');
         window.location.href = '/login';
         throw refreshErr;
       }
     }
 
     return res;
   } catch (err) {
     console.error('API 요청 에러:', err);
     throw err;
   }
 }
 
 export default apiRequest;
 
  